import React from "react";
import "./styles.scss";
import { setSelectedRestaurantTab } from "../../common/features/restaurant/restaurantAction";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { cleanedPath } from "../../common/utils";
import { reservatonMenuApiCall } from "../../common/features/cart/cartActions";

interface MenuDrawerProps {
    showMenuDrawer: boolean;
    setShowMenuDrawer: (show: boolean) => void;
}
const MenuDrawer = ({ showMenuDrawer, setShowMenuDrawer }: MenuDrawerProps) => {
    const exploreMenu = useSelector((state: any) => state.restaurant.exploreMenu?.menu);
    const selectedTab = useSelector((state: any) => state.restaurant.selectedRestaurantTab);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let { restaurantSlug,itemName } = useParams<any>();
    const slugFromLocalStorage = localStorage.getItem("restaurant") && JSON.parse(
        localStorage.getItem("restaurant") || ""
    );
    const selectedDeliveryType = useSelector((state: any) => state.restaurant.selectedDeliveryType)
    const handleTabClick = (e: React.MouseEvent, tab: string) => {
        e.stopPropagation();
        dispatch(setSelectedRestaurantTab(tab));
        setShowMenuDrawer(false);
        localStorage?.setItem("selectedTab", tab);        
    }
    const handleClose = (e: React.MouseEvent) => {
        e.stopPropagation();
        setShowMenuDrawer(false);
    }
    return (
        <>            {/* Mobile Menu Drawer */}
            {showMenuDrawer && (
                <div className="mobile-menu-drawer" onClick={handleClose}>
                    <div className="mobile-menu-drawer-content">
                        <div className="mobile-menu-drawer-header">
                            <div className="mobile-menu-drawer-close-button" onClick={handleClose}>
                                ✕
                            </div>
                        </div>
                        <div className="mobile-menu-drawer-items">
                            {/* <div className={`menu-drawer-item headerLinks ${selected Tab === "home" ? "active" : ""}`}
                              onClick={() => handleTabClick("home")}>Home</div> */}
                            <div className={`menu-drawer-item  ${selectedTab === "restaurantInfo" ? "active" : ""}`}
                                onClick={(e) =>{
                                    handleTabClick(e, "restaurantInfo")
                                    navigate(`${cleanedPath(window.location.pathname, !!(itemName||""))}/restaurantinfo`
                                )
                                }} 
                               >Restaurant Info</div>
                            {exploreMenu && exploreMenu?.length > 0 ? (
                                <div className={`menu-drawer-item  ${selectedTab === "explore" ? "active" : ""}`}
                                    onClick={(e) => {   
                                        handleTabClick(e, "explore")
                                        navigate(
                                            `${cleanedPath(window.location.pathname, !!(itemName||""))}/exploremenu`
                                        )
                                    }
                                        }>Explore</div>
                            ) : null}
                            <div className={`menu-drawer-item  ${selectedTab === "menu" ? "active" : ""}`}
                                onClick={(e) =>{
                                    handleTabClick(e, "menu")
                                    navigate(
                                        `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/menu/${selectedDeliveryType}`
                                       )
                                }
                              }>Full Menu</div>
                            <div className={`menu-drawer-item  ${selectedTab === "reservation" ? "active" : ""}`}
                                onClick={() => {navigate(
                                    `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/Reservation`
                                )
                            dispatch(reservatonMenuApiCall())
                            }}
                            >Reservation</div>
                            <div className={`menu-drawer-item  ${selectedTab === "checkIn" ? "active" : ""}`}
                                onClick={() => { navigate(
                                    `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/checkin`
                                )
                            dispatch(reservatonMenuApiCall())
                            }
                            }
                            >Check In</div>
                        </div>
                    </div>
                </div>
            )}</>
    );
};

export default MenuDrawer;